var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9121 15C16.2258 15 18.9121 12.3137 18.9121 9C18.9121 5.68629 16.2258 3 12.9121 3C9.5984 3 6.91211 5.68629 6.91211 9C6.91211 12.3137 9.5984 15 12.9121 15Z",
    stroke: "#E6E6E8",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81836 20.2508C4.73986 18.6544 6.06539 17.3287 7.66169 16.407C9.25799 15.4853 11.0688 15 12.9121 15C14.7554 15 16.5662 15.4853 18.1625 16.407C19.7588 17.3287 21.0844 18.6544 22.0059 20.2508",
    stroke: "#E6E6E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3642558973d94df61d3eb4d89ea03d02.svg";
export { ForwardRef as ReactComponent };